import script from "./VirtualVideo.vue?vue&type=script&lang=ts&setup=true"
export * from "./VirtualVideo.vue?vue&type=script&lang=ts&setup=true"

import "./VirtualVideo.vue?vue&type=style&index=0&id=41df5e0c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41df5e0c"]])

export default __exports__